import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '@/shared/store/services/baseQueryWithReauth';

export const API_TAG_TYPES = [
  'tenants-directory',
  'platform-active-languages',
  'platform-languages-catalogue',
  'platform-audit-log',
  'users-directory',
  'clients-directory',
  'client-detail',
  'projects-under-client',
  'project-detail',
  'project-picker',
  'recent-activity-picker',
  'tenant-audit-log',
  'password-reset-token-status',
  'own-profile',
  'timer-indicator',
  'tasks-under-project',
  'task-picker',
  'tags-under-project',
  'tag-picker',
  'enabled-languages-picker',
  'tenant-settings',
  'teams-directory',
  'team-detail',
  'team-lead-reach',
  'time-entries-day',
  'time-entries-list',
  'weekly-grid',
  'report-summary',
  'report-detail',
  'user-detail',
  'tenant-detail',
  'tenant-settings',
] as const;

export type ApiTagType = (typeof API_TAG_TYPES)[number];

export const apiSlice = createApi({
  reducerPath: 'api',
  baseQuery: baseQueryWithReauth,
  tagTypes: API_TAG_TYPES,
  endpoints: () => ({}),
});
